module.exports = __webpack_public_path__ + "img/arrow-down.04de6fd3.svg";